<template>
	<div class="consumer-content">
		<div class="content-info">
			<div class="content-time">
				{{timeText}}
			</div>
			<div class="content-text" :class="animateClass">
				<p v-for="(item, index) in contentText" :key="index" v-html="item"></p>
			</div>
		</div>
		<div class="content-img">
			<img :src="chatContent.photo" alt="">
		</div>
	</div>
</template>

<script>
	// 用户内容
	export default {
		name: 'consumer-content',
		props: {
			chatContent: {
				type: Object,
				default: () => {
					return {
						// type
						// time
						// content
						// animate
					}
				}
			}
		},
		methods: {
			textFilter(text = '') {
				let textArr = text;
				// const reg = /(((https?:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/ig;
				if (typeof text === 'string') {
					textArr = [ text ];
				}
				return textArr.map(_text => {
					_text = _text.replace(/^[\s\r\n]+/, '');
					if (/^https?|HTTPS?/.test(_text)) {
						if (/\.(png|jpg|jpeg|gif)$/.test(_text)) {
							return `<img src="${_text}" width="100%" alt="">`;
						}
						return `<a href="${_text}" target='_blank'>${_text}</a>`;
					}
					return _text;
				});
			}
		},
		computed: {
			timeText() {
                let text = '我';
                if (this.chatContent.time) {
                    const time = this.$time.simplify(this.chatContent.time);
                    text += ' ';
                    text += time.year ? (time.year + '年') : '';
                    text += time.month ? (time.month + '月') : '';
                    text += time.date ? (time.date + '日 ') : '';
                    text += time.hms;
                }
                return text;
			},
			contentText() {
				return this.textFilter(this.chatContent.content);
				// if (typeof this.chatContent.content === 'string') {
				// 	return [ this.chatContent.content ];
				// }
				// return this.chatContent.content && this.chatContent.content.length ? this.chatContent.content : [];
			},
			animateClass() {
				return this.chatContent.animate || false ? 'animateSilde' : '';
			}
		}
	}
</script>

<style scoped lang="less">
	.consumer-content{
		margin-left: 40px;
		width: calc(100% - 40px);
		display: flex;
	}
	.content-img, .content-img img{
		width: 28px;
		height: 28px;
	}
	.content-img{
		padding: 6px;
		text-align: center;
	}
	.content-info{
		width: calc(100% - 40px);
		display: flex;
		flex-wrap: wrap;
		justify-content: flex-end;
	}
	.content-time{
		width: 100%;
		height: 24px;
		font-size: 12px;
		line-height: 24px;
		text-align: right;
	}
	.content-text{
		max-width: calc(100% - 12px);
		padding: 6px;
		font-size: 13px;
		border-radius: 6px;
		background-color: #EEEEEE;
	}
	.content-text p{
		/* width: 100%; */
		white-space: normal;
		word-wrap: break-word;
	}
	.content-text p img{
		width: 100%;
	}
	.animateSilde{
		opacity: 0;
		transform: translateY(70%);
		visibility: visible;
		animation: slideIn .5s forwards
	}
	@keyframes slideIn{
		from{
			opacity: 0;
			transform: translateY(70%);
		}
		to{
			opacity: 1;
			transform: translateY(0%);
		}
	}
</style>
